var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isShow)?_c('app-layout',[_c('template',{slot:"main"},[_c('router-view')],1)],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }